import window from 'global/window';
import {userPrefs} from '@netx/core-user/collections/singletons/userPreferences';

export const setPreference = (key: string, value: any) =>
	window.Netx?.userProfile?.id > 0 && userPrefs.setUserPreference(key, value);

export default setPreference;
